import { ApplicationInsights, DistributedTracingModes } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { AppInsightKey, BuildNumber, Environment } from "env-config";

const browserHistory = createBrowserHistory({ basename: "" });
const reactPlugin = new ReactPlugin();

// https://docs.microsoft.com/en-gb/azure/azure-monitor/app/javascript#telemetry-initializers
var telemetryInitializer = (envelope) => {
    envelope.tags["ai.cloud.role"] = "stock-ledger-portal-ui";
    envelope.data.buildNumber = BuildNumber();
    envelope.data.environment = Environment();
};

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: AppInsightKey(),
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
        },
        // https://docs.microsoft.com/en-gb/azure/azure-monitor/app/javascript#enable-correlation
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        correlationHeaderExcludedDomains: ["*.eu.auth0.com", "auth.bybox.com"],
        distributedTracingMode: DistributedTracingModes.W3C,
        disableFetchTracking: false,
    },
});
appInsights.loadAppInsights();
appInsights.addTelemetryInitializer(telemetryInitializer);

export { reactPlugin, appInsights };
